
import { Box, Checkbox, Grid, MenuItem, Stack, SxProps, Typography } from '@mui/material';
import React from 'react'
import InputTextField from '../input/inputTextField';
import AutocompleteSelect from '../select/autoCompleteSelect';
import InputDatePicker from '../input/inputDatePicker';
import FilterSelect from '../select/filterSelect';
import moment from 'moment';
// import TextEditorCustom from '../text-editor/TextEditorCustom';
import UploadFile, { uploadFileProps } from '../upload/UploadFile';
// import InputTextMask, { TextMaskTypeProps } from '../input/InputTextMask';
// import RadioCustom from '../radio/RadioCustom';
// import DateRankPicker, { dateRangeProps } from '../input/dateRankPicker';
// import TextEditorCustom from '../text-editor/TextEditorCustom';

export type gridColType = {
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
};

export type TEXT_FIELD_TYPE = {
    value?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    heading?: string;
    helperText?: string;
    placeholder?: string;
    startAdornment?: React.ReactNode;
    enableTextArea?: {};
    disabled?: boolean;
    otherProps?: any;
    required?: boolean;
    disablePaddingMultiline?: boolean;
    disabledAutoComplete?: boolean;
    inputHeight?: any;
    row?: number;
    maxRows?: number;
    minRow?: number;
    multiline?: boolean;
    disableColor?: string;
    onkeypress?: any;
    type?: string;
    endAdornment?: React.ReactNode;
    pattern?: string,
    maxLength?: number,
    onClick?: () => void;
    enableCountMaxLength?: boolean;
    headingColor?: React.CSSProperties['color']

};
export type TEXT_MASK_TYPE = {
    mode: 'amount' | 'phone' | 'thai-id' | 'number' | 'latlng';
    value?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    heading?: string;
    helperText?: string;
    placeholder?: string;
    startAdornment?: React.ReactNode;
    enableTextArea?: {};
    disabled?: boolean;
    otherProps?: any;
    required?: boolean;
    disableColor?: string;
    endAdornment?: React.ReactNode
    disabledAutoComplete?: boolean;
};
export type AUTO_COMPLETE_TYPE = {
    value: any;
    onChange: any;
    heading?: string | any;
    helperText?: string;
    placeholder?: string;
    labelId: string;
    options: any[];
    required?: boolean;
    otherProps?: any;
    disabled?: boolean;
    onInputChange?: any;
    inputValue?: string;
    freesolo?: boolean;
    getOptionLabel: (option: any) => string;
    startAdornment?: React.ReactNode;
    endAdornment?: React.ReactNode;
    isFilter?: boolean;
    PopperComponent?: any;
    open?: boolean;
    filterOptionsCustom?: (op: any, state: any) => any;
};
export type DATE_TYPE = {
    value: string;
    onChange: (date_format: string) => void;
    heading?: string;
    placeholder?: string;
    otherProps?: any;
    allowClear?: boolean;
    required?: boolean;
    onClear?: () => void;
    helperText?: string;
    disabled?: boolean;
    disableStartDate?: any;
    disableEndDate?: any;
};

export type SELECT_TYPE = {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    heading?: string;
    options: { label: string; value: string | number, icon?: any, other?: any }[];
    placeholder?: string;
    otherProps?: any;
    required?: boolean;
    labelId: string;
    selectId: string;
    disabled?: boolean;
    value: any;
    helperText?: string;
    renderValue?: (option: any) => any;
    formControlStyle?: SxProps;
    onCheckBox?: any;
    checkBoxValue?: string[] | number[];
    multiple?: boolean;
};
export type COMPONENT_TYPE = {
    element: React.ReactNode;
}
type dataType = {
    value: string;
    label: string;
    sx?: SxProps;
    renderAfter?: React.ReactNode;
}

export type RADIO_TYPE = {
    sx?: SxProps;
    heading?: string;
    dataList: dataType[];
    defaultValue?: string;
    value?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    row?: boolean;
    disabled?: boolean;
    labelClassName?: string;
    headingBold?: string;
    subHeadingBold?: string;
    required?: boolean;
}
export type TEXT_EDITOR_TYPE = {
    textString: string;
    onChange: (text: string) => void;
    sx?: SxProps;
    height?: string;
    disabled?: boolean;
    heading?: string;
    placeholder?: string;
};
export type UPLOAD_FILE_TYPE = uploadFileProps

export type FilterProps =
    | {
        type: "TEXT_FIELD";
        seq: number;
        fieldProps: TEXT_FIELD_TYPE;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "AUTO-COMPLETE";
        seq: number;
        fieldProps: AUTO_COMPLETE_TYPE;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "DATE";
        seq: number;
        fieldProps: DATE_TYPE;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "SELECT";
        seq: number;
        fieldProps: SELECT_TYPE;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "TEXT-EDITOR";
        seq: number;
        fieldProps: TEXT_EDITOR_TYPE;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "TEXT-EDITOR";
        seq: number;
        fieldProps: TEXT_EDITOR_TYPE;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    | {
        type: "UPLOAD-FILE";
        seq: number;
        fieldProps: UPLOAD_FILE_TYPE;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    // | {
    //     type: "TEXT-MASK";
    //     seq: number;
    //     fieldProps: TextMaskTypeProps;
    //     gridProps?: gridColType;
    //     sx?: SxProps;
    //     hidden?: boolean;
    // }
    | {
        type: "COMPONENT";
        seq: number;
        fieldProps: COMPONENT_TYPE;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    }
    // | {
    //     type: "DATE_RANGE";
    //     seq: number;
    //     fieldProps: dateRangeProps;
    //     gridProps?: gridColType;
    //     sx?: SxProps;
    //     hidden?: boolean;
    // }
    | {
        type: "RADIO";
        seq: number;
        fieldProps: RADIO_TYPE;
        gridProps?: gridColType;
        sx?: SxProps;
        hidden?: boolean;
    };


type Props = {
    typeProps: FilterProps[];
    otherProps?: { spacing?: number }
    sxContainer?: SxProps;
    disabledAllField?: boolean;
    heading?: string;
    headingContent?: React.ReactNode;
    headingAlign?: React.CSSProperties['justifyContent'];
    headingClassName?: string;
}


const StateComponents = React.memo((props: Props) => {
    const { typeProps, otherProps, sxContainer, heading, headingAlign } = props
    return (
        <Box sx={sxContainer}>
            {heading && (
                <Box sx={{
                    display: "flex", flexDirection: {
                        xs: "column",
                        lg: "row"
                    }
                }} justifyContent={headingAlign} className={`w-full gap-4 ${props.headingClassName}`}>
                    <Typography whiteSpace={"nowrap"} my={1} variant='h5'>
                        {heading}
                    </Typography>
                    {props.headingContent}
                </Box>
            )}
            <Grid container spacing={otherProps?.spacing} >
                {typeProps.filter((x) => !x.hidden).sort((x, y) => x.seq - y.seq).map((list) => {
                    return (
                        <React.Fragment key={list.seq}>
                            {(() => {
                                switch (list.type) {
                                    case 'TEXT_FIELD':
                                        return <Grid sx={list.sx} item key={list.seq} {...list.gridProps} >
                                            <InputTextField
                                                {...list.fieldProps}
                                                {...(list.fieldProps.enableTextArea && {})}
                                                disabled={props.disabledAllField || list.fieldProps.disabled}
                                                onchange={list.fieldProps.onChange}
                                            />
                                        </Grid>
                                    // case 'TEXT-MASK':
                                    //     return <Grid sx={list.sx} item key={list.seq} {...list.gridProps} >
                                    //         <InputTextMask
                                    //             {...list.fieldProps}
                                    //             // {...(list.fieldProps.enableTextArea && {})}
                                    //             disabled={props.disabledAllField || list.fieldProps.disabled}

                                    //             onChange={list.fieldProps.onChange}
                                    //         />
                                    //     </Grid>
                                    case 'AUTO-COMPLETE':
                                        return <Grid sx={list.sx} item key={list.seq} {...list.gridProps} >
                                            <AutocompleteSelect
                                                {...list.fieldProps}
                                                disabled={props.disabledAllField || list.fieldProps.disabled}
                                            />
                                        </Grid>
                                    case 'DATE':
                                        return <Grid sx={list.sx} item key={list.seq} {...list.gridProps} >
                                            <InputDatePicker
                                                {...list.fieldProps}
                                                onChange={(e: any) => list.fieldProps.onChange(moment(e).format("YYYY-MM-DD"))}
                                                disabled={props.disabledAllField || list.fieldProps.disabled}

                                            />
                                        </Grid>
                                    // case 'DATE_RANGE':
                                    //     return <Grid sx={list.sx} item key={list.seq} {...list.gridProps} >
                                    //         <DateRankPicker
                                    //             {...list.fieldProps}
                                    //         // disabled={props.dsabledAllField || list.fieldProps.disabled}

                                    //         />
                                    //     </Grid>
                                    case 'SELECT': return <Grid sx={list.sx} item key={list.seq} {...list.gridProps} >
                                        <FilterSelect {...list.fieldProps}
                                            onchange={list.fieldProps.onChange}
                                            disabled={props.disabledAllField || list.fieldProps.disabled}
                                            options={list.fieldProps.options.map((op: any, i: number) =>
                                                <MenuItem value={op.value} key={i + 1}>
                                                    {list.fieldProps.onCheckBox ? (
                                                        <>
                                                            <Checkbox
                                                                checked={list.fieldProps.value.filter((x: any) => x === op.value).length > 0}
                                                            />
                                                            <Box sx={{ width: "100%", display: 'flex', justifyContent: "space-between" }}>
                                                                <span>
                                                                    {`${op.label}`}
                                                                </span>
                                                                {op.other && (
                                                                    <span>
                                                                        {`${op.other && op.other}`}
                                                                    </span>
                                                                )}
                                                            </Box>
                                                        </>
                                                    ) : (

                                                        <Stack direction="row" spacing={1} sx={{ alignContent: 'center', alignItems: 'center' }}>
                                                            {op.icon && (<Box sx={{ position: 'relative', width: 30, height: 30, display: 'flex', alignItems: 'center' }}>{op.icon}</Box>)}
                                                            <span>{op.label}</span>
                                                        </Stack>
                                                    )}
                                                </MenuItem>
                                            )}
                                        />
                                    </Grid>
                                    // case 'TEXT-EDITOR':
                                    //     return <Grid sx={list.sx} item key={list.seq} {...list.gridProps}>
                                    //         <TextEditorCustom {...list.fieldProps} />
                                    //     </Grid>
                                    case 'UPLOAD-FILE':
                                        return (
                                            <Grid sx={list.sx} item key={list.seq} {...list.gridProps}>
                                                <UploadFile
                                                    {...list.fieldProps}
                                                    noClick={props.disabledAllField || list.fieldProps.noClick}
                                                />
                                            </Grid>
                                        );
                                    case 'COMPONENT':
                                        return (
                                            <Grid sx={list.sx} item key={list.seq} {...list.gridProps}>
                                                {list.fieldProps.element}
                                            </Grid>
                                        );
                                    // case 'RADIO':
                                    //     return (
                                    //         <Grid sx={list.sx} item key={list.seq} {...list.gridProps}>
                                    //             <RadioCustom
                                    //                 disabled={props.disabledAllField || list.fieldProps.disabled}
                                    //                 {...list.fieldProps} />
                                    //         </Grid>
                                    //     );
                                    default:
                                        return null;
                                }
                            })()}
                        </React.Fragment>
                    )
                })}
            </Grid>
        </Box>
    )
})

export default StateComponents